import React from "react";
import "./ListContainerRight.css";
import RecentPosts from "../Posts/RecentPosts";
const ListContainerRight = () => {
  return (
    <div className="ListContainerRight">
      <RecentPosts />
    </div>
  );
};

export default ListContainerRight;
